export default __webpack_public_path__ + "static/media/sidebar-menu.76cd03a5.svg";